// eslint-disable-next-line import/prefer-default-export
export const SL_IMAGE_RESIZING_FULL = 'sl_web_image_resizing_not_homepage';
